import "core-js/modules/es.array.push.js";
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "coupon-widget-item-left"
};
const _hoisted_2 = {
  key: 0,
  class: "coupon-widget-item-left-symbol"
};
const _hoisted_3 = {
  class: /*#__PURE__*/_normalizeClass(['coupon-widget-item-middle'])
};
const _hoisted_4 = {
  class: "coupon-widget-item-middle-description"
};
const _hoisted_5 = {
  class: "coupon-widget-item-middle-requirement"
};
const _hoisted_6 = {
  class: "coupon-widget-item-middle-timer"
};
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { COUPON_STATUS, MAXIMUM_PRICE_RANGE } from '@/configs/views/couponWidget';
import { useLess } from '@/models/hooks';
import { useI18n } from 'vue-i18n';
export default {
  __name: 'CouponItem',
  props: {
    couponItem: {
      type: Object,
      default: () => null
    },
    couponConfig: {
      type: Object,
      default: () => null
    }
  },
  emits: ['handleRedeemPromotion'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    useLess('views/landingPage/couponWidget/CouponItem.less');
    const router = useRouter();
    const {
      t
    } = useI18n();
    const couponInfo = {
      ACTIVE: {
        btnText: t('modules.couponsList.TAKE_IT_NOW'),
        btnClass: 'active-btn',
        styleClass: 'active',
        backgroundKey: 'backgroundColorBefore',
        textColorKey: 'textColorBefore'
      },
      REDEEMED: {
        btnText: t('modules.couponsList.TO_USE'),
        btnClass: 'redeemed-btn',
        styleClass: 'redeemed',
        backgroundKey: 'backgroundColorAfter',
        textColorKey: 'textColorAfter'
      },
      USED: {
        btnText: t('modules.couponsList.USED'),
        btnClass: 'used-btn',
        styleClass: 'used',
        backgroundKey: 'backgroundColorUse',
        textColorKey: 'textColorUse'
      },
      EXHAUSTED: {
        btnText: t('modules.couponsList.ALREADY_SOLD_OUT'),
        btnClass: 'exhausted-btn',
        styleClass: 'exhausted',
        backgroundKey: 'backgroundColorIsFinished',
        textColorKey: 'textColorIsFinished'
      },
      EXPIRED: {
        btnText: t('modules.couponsList.EXPIRED'),
        btnClass: 'expired-btn',
        styleClass: 'expired',
        backgroundKey: 'backgroundColorHasEnd',
        textColorKey: 'textColorHasEnded'
      },
      NOT_STARTED: {
        btnText: t('modules.couponsList.NOT_STARTED'),
        btnClass: 'not-start-btn',
        styleClass: 'not-start',
        backgroundKey: 'backgroundColorHasEnd',
        textColorKey: 'textColorHasEnded'
      }
    };
    const isShowArrow = computed(() => {
      return props.couponItem.status === COUPON_STATUS.ACTIVE || props.couponItem.status === COUPON_STATUS.REDEEMED;
    });
    const couponClass = computed(() => {
      var _couponInfo$props$cou, _couponInfo$props$cou2;
      return (_couponInfo$props$cou = (_couponInfo$props$cou2 = couponInfo[props.couponItem.status]) === null || _couponInfo$props$cou2 === void 0 ? void 0 : _couponInfo$props$cou2.styleClass) !== null && _couponInfo$props$cou !== void 0 ? _couponInfo$props$cou : '';
    });
    const couponStyle = computed(() => {
      return {
        color: props.couponConfig[couponInfo[props.couponItem.status].textColorKey],
        background: props.couponConfig[couponInfo[props.couponItem.status].backgroundKey]
      };
    });
    const handleRedeemPromotion = () => {
      if (props.couponItem.status === COUPON_STATUS.REDEEMED) {
        router.push({
          name: 'productList',
          params: {
            type: 'default'
          }
        });
        return;
      }
      if (props.couponItem.status !== COUPON_STATUS.ACTIVE) return;
      emit('handleRedeemPromotion');
    };
    return (_ctx, _cache) => {
      const _component_van_icon = _resolveComponent("van-icon");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["coupon-widget-item", [couponClass.value]]),
        style: _normalizeStyle(couponStyle.value)
      }, [_createElementVNode("div", _hoisted_1, [__props.couponItem.isShowCurrencyUnit ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t('common.currencyUnit')), 1)) : _createCommentVNode("", true), _createElementVNode("span", {
        class: _normalizeClass(['coupon-widget-item-left-price', {
          'coupon-widget-item-left-price-max': Number(__props.couponItem.priceText) > _unref(MAXIMUM_PRICE_RANGE)
        }])
      }, _toDisplayString(__props.couponItem.priceText), 3)]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('common.FULL_REDUCTION_COUPON', {
        amount: __props.couponItem.thresholds[0].currencyAmount.amount,
        promotion: __props.couponItem.priceText
      })) + " ", 1), _createElementVNode("div", _hoisted_5, _toDisplayString(__props.couponItem.requirement), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(__props.couponItem.termOfValidity), 1)]), _createElementVNode("div", {
        class: "coupon-widget-item-right",
        onClick: handleRedeemPromotion
      }, [_createElementVNode("div", {
        class: _normalizeClass(['coupon-widget-item-right-button', couponInfo[__props.couponItem.status].btnClass])
      }, [_createTextVNode(_toDisplayString(couponInfo[__props.couponItem.status].btnText) + " ", 1), isShowArrow.value ? (_openBlock(), _createBlock(_component_van_icon, {
        key: 0,
        name: "arrow"
      })) : _createCommentVNode("", true)], 2)])], 6);
    };
  }
};